/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { v4 } from "uuid";
import HomeLayout from "../../Components/ehealth/Layout";
import { getIcon } from "../../Components/Functions";
import { ModalBox } from "../../Components/ModalBox";
import { loggedUser } from "../../Constants/menus";
import { getMoreReviews, updateProfile } from "../../Redux/Specialist/actions";
import {
	updateMyPatientsFilters,
	updateRecords,
} from "../../Redux/MyPatients/actions";
import { addRemoveFavourite } from "../search/SearchEngine";
import AppointmentBook from "./AppointmentBook";
import FixedBar from "./FixedBar";
import Modals from "./Modals";
import RelatedSpecialists from "./RelatedSpecialists";
import ReviewModals, { ReviewItem } from "./ReviewModals";
import ErrorPage from "../../Components/ErrorPage";
import LoadingPage from "../../Components/LoadingPage";

const DoctorPage = (props) => {
	const { profile, reviews, updateProfile, mypatients } = props;
	let { username } = useParams();
	const [is_found, setIsFound] = React.useState();
	// const [is_favourite, setIsFavourite] = React.useState(profile?.is_favourite);

	const length = mypatients.results.length;
	const [is_favourite, setIsFavourite] = React.useState(length);
	const [read_more, setReadMore] = React.useState(false);
	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		setIsFavourite(length);
	}, [length]);

	const updateFilters = (e) => {
		updateMyPatients({ filters: { ...props?.mypatients?.filters, ...e } });
	};

	const updateMyPatients = (e) => {
		props.updateMyPatientsFilters({ ...props?.mypatients, ...e });
	};

	const load = () => {
		props.updateRecords({ ...props?.mypatients });
	};

	const init = () => {
		setLoading(true);
		updateProfile(username, (res) => {
			setIsFound(res?.profile?.id > 0);
			setLoading(false);
		});
	};

	React.useEffect(() => {
		init();
		load();
	}, []);
	return (
		<HomeLayout>
			{(loading && <LoadingPage />) || (
				<>
					{(!is_found && <ErrorPage title="Account Not Found" />) || (
						<>
							<FixedBar />
							<div
								id="presentation"
								className="section has-navbar-padding"
								data-listing="event"
							>
								<div className="container">
									<div className="listing-title">
										<div className="left">
											<h2 className="title is-bold is-4">
												{profile?.header_title}
											</h2>
											<div>
												<a>
													<i data-feather="star" />
													<span>
														{profile?.avg_rating} ({reviews?.count || 0})
													</span>
												</a>
												<a>
													{profile?.address_lga}, {profile?.address_state}
												</a>
											</div>
										</div>
										<div className="right">
											<a
												className="modal-trigger"
												data-modal="listing-share-modal"
											>
												<i data-feather="share-2" />
												<span>Share</span>
											</a>
											{loggedUser?.username && (
												<a
													className="modal-trigger"
													onClick={(e) => {
														e.preventDefault();
														addRemoveFavourite({ id: profile?.id }, (res) => {
															setIsFavourite(res?.id);
														});
													}}
													dangerouslySetInnerHTML={{
														__html:
															getIcon("heart") +
															`<span>${is_favourite ? "Remove" : "Add"}</span>`,
													}}
												/>
											)}
										</div>
									</div>
									<div id="lightgallery" className="listing-cover-wrapper is-1">
										<a
											className="listing-cover has-background-image"
											style={{
												backgroundImage: `url("${
													profile?.background_image ||
													require("../../assets/images/profile_image_placeholder.png")
														.default
												}")`,
												backgroundSize: "cover",
												backgroundPosition: "center",
												backgroundRepeat: "no-repeat",
											}}
											href={profile?.background_image}
											data-demo-href={profile?.background_image}
										/>
									</div>
									<div className="listing-details">
										<div className="columns">
											<div
												className={`column is-${
													loggedUser?.username !== profile?.username
														? "7"
														: "12"
												}`}
											>
												<div className="listing-subtitle">
													<div className="left">
														<h3 className="title is-5 is-narrow">
															{profile?.title} {profile?.name}
														</h3>
														{(profile?.is_verified && (
															<p
																style={{ marginTop: 10, fontWeight: "bold" }}
																className="text-primary"
															>
																<i
																	className="la la-shield"
																	style={{
																		marginRight: 5,
																		padding: 5,
																		border: "1px solid",
																		borderRadius: 20,
																	}}
																/>
																<span>Verified</span>
															</p>
														)) || (
															<p
																style={{ marginTop: 10, fontWeight: "bold" }}
																className="text-danger"
															>
																<i
																	className="la la-exclamation"
																	style={{
																		marginRight: 5,
																		padding: 5,
																		border: "1px solid",
																		borderRadius: 20,
																	}}
																/>
																<span>Unverified</span>
															</p>
														)}
													</div>
													<div className="right">
														<a>
															<img
																src={
																	profile?.image ||
																	(profile?.gender === "MALE"
																		? require("../../assets/images/doctor-placeholder-male.jpg")
																				.default
																		: require("../../assets/images/doctor-placeholder-female.jpg")
																				.default)
																}
																alt=""
															/>
														</a>
													</div>
												</div>
												<h3 className="title is-5 mb-4">Categories</h3>
												<div class="near-tags mb-5">
													<div class="tags">
														{(profile?.categories || []).map((e) => {
															return (
																<span
																	class="categories-tag-list-item tag"
																	category-id={e.id}
																>
																	{e.title}
																</span>
															);
														})}
													</div>
												</div>
												{(profile?.services || []).length > 0  && 
												<>
												
													<h3 className="title is-5 mb-4">Services</h3>
													<div className="listing-features">
														{(profile?.services || []).map((e) => {
															return (
																<div className="listing-feature" key={v4()}>
																	<i className="la la-check-square" />
																	<div className="meta">
																		<span>{e.title}</span>
																		<span>{e.description}</span>
																	</div>
																</div>
															);
														})}
													</div>
												
												</>}
												<div className="listing-content">
													<h3
														className="title is-5 is-narrow"
														style={{ marginBottom: 15 }}
													>
														About me
													</h3>

													<div
														data-x-show="isDescriptionExpanded === false"
														style={{ marginTop: 15 }}
													>
														<style>
															{`	
														${
															!read_more
																? `
														.doctor-details {
															overflow: hidden;
															display: -webkit-box;
															-webkit-line-clamp: 5;
															-webkit-box-orient: vertical;
														}
														`
																: ""
														}
															
														`}
														</style>
														<p
															className="doctor-details"
															dangerouslySetInnerHTML={{
																__html: `${profile?.about}`.replaceAll(
																	"\n",
																	"<br/>",
																),
															}}
														/>
													</div>
													<a
														href="#"
														className="underlink"
														onClick={(e) => {
															e.preventDefault();
															setReadMore(!read_more);
														}}
													>
														{!read_more ? "Read more" : "Read less"}
													</a>
												</div>

												<div className="listing-requirements">
													<h3 className="title is-5 is-narrow">
														Mode of communication
													</h3>
													<div className="requirements-list">
														{(profile?.communications || []).map((e) => {
															return (
																<div className="requirements-item" key={v4()}>
																	<div
																		className="icon-container"
																		dangerouslySetInnerHTML={{
																			__html: getIcon(e.icon || "check"),
																		}}
																	/>
																	<span>{e.name}</span>
																</div>
															);
														})}
													</div>
												</div>
											</div>
											{/*Sticky form*/}
											{loggedUser?.username !== profile?.username && (
												<div className="column is-4 is-offset-1">
													<div className="sticky-outer">
														<div className="sticky-wrapper">
															<div className="sticky-wrapper-inner">
																{/*Booking form*/}
																{is_found && (
																	<AppointmentBook profile={profile} />
																)}
															</div>
														</div>
													</div>
												</div>
											)}
										</div>
									</div>

									{reviews?.results?.length > 0 && (
										<div id="comments" className="host-comments">
											<h4 className="title is-5 is-narrow">
												<i data-feather="star" />
												<span>
													{profile?.avg_rating} ({reviews?.count} comments)
												</span>
											</h4>
											<div className="comments">
												<div className="columns is-multiline b-columns-half-tablet-p">
													{/*Comment*/}
													{(reviews?.results || [])
														.slice(0, 10)
														.map((review) => {
															return <ReviewItem key={v4()} review={review} />;
														})}
												</div>
												{reviews?.count > 10 && (
													<>
														<div className="comments-action">
															<button
																id="read-all-commentbtn"
																className="button is-heavy modal-trigger"
																data-modal="comments-modal"
															>
																See all {reviews?.count} comments
															</button>
														</div>
														<ModalBox
															buttonId={"read-all-commentbtn"}
															title={`Comments (${reviews?.count})`}
														>
															<ReviewModals {...props} username={username} />
														</ModalBox>
													</>
												)}
											</div>
										</div>
									)}
									<RelatedSpecialists />
								</div>
							</div>
							<Modals />
						</>
					)}
				</>
			)}
		</HomeLayout>
	);
};

const mapStateToProps = ({ mypatients, specialist }) => {
	return {
		profile: specialist?.profile || [],
		reviews: specialist?.reviews,
		mypatients,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateProfile: (e, c) => dispatch(updateProfile(e, c)),
		getMoreReviews: (e) => dispatch(getMoreReviews(e)),
		updateMyPatientsFilters: (e) => dispatch(updateMyPatientsFilters(e)),
		updateRecords: (e) => dispatch(updateRecords(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorPage);
